module.exports = __webpack_public_path__ + "img/SPPREMIUM.90e173d1.png";